import request from '#api/axios';

interface Award {
  id: string; // 수상의 고유 ID
  createdAt: string; // 수상 기록 생성 일자 (ISO 8601 형식의 날짜 문자열)
  updatedAt: string; // 수상 기록 갱신 일자 (ISO 8601 형식의 날짜 문자열)
  accountId: string; // 수상과 연관된 계정 ID
  name: string; // 수상명
  gotAt: string; // 수상 일자 (ISO 8601 형식의 날짜 문자열)
  institution: string; // 수상 기관명
}

export const getAward = async (awardId: string) => {
  const res = await request<Award>({
    method: 'get',
    url: `/awards/${awardId}`
  });

  return res.data;
};
